import React, { lazy, Suspense, useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { FEATURE_FLAGS, useFeatureFlag } from 'app/hooks/useFeatureFlag';
import ErrorBoundary from 'app/components/common/ErrorBoundary';
import { AskMaxLauncher } from './AskMaxLauncher';
import { useAskMaxStore } from './store';

// The panel pulls in the ElevenLabs SDK (and LiveKit), which shouldn't sit in the entry
// chunk; AskMaxLauncher is its own module so this host never imports the panel statically.
const AskMaxPanel = lazy(() =>
  import('./AskMaxPanel').then((m) => ({ default: m.AskMaxPanel }))
);

export const AskMaxHost: React.FC = () => {
  const { pathname } = useLocation();
  const enabled = useFeatureFlag(FEATURE_FLAGS.ASK_MAX);
  const open = useAskMaxStore((s) => s.open);
  const setOpen = useAskMaxStore((s) => s.setOpen);
  const live = useAskMaxStore((s) => s.session !== null);
  const [everOpened, setEverOpened] = useState(false);
  useEffect(() => {
    if (open) setEverOpened(true);
  }, [open]);
  if (!enabled) return null;
  const onCapablePage = matchPath('/agent/dashboard/*', pathname) !== null;
  return (
    <ErrorBoundary fallback={null}>
      {onCapablePage && !open && (
        <AskMaxLauncher onClick={() => setOpen(true)} live={live} />
      )}
      {everOpened && (
        <Suspense fallback={null}>
          <AskMaxPanel open={open} onOpenChange={setOpen} />
        </Suspense>
      )}
    </ErrorBoundary>
  );
};
